import React from "react";
import { useLocation, Route, Switch } from "react-router-dom";
import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/SideBar";
// import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import routes from "routes/member";
import sidebarImage from "assets/img/sidebar-4.jpg";

function Admin() {
  const [image] = React.useState(sidebarImage);
  const [color] = React.useState("primary");
  const [hasImage] = React.useState(true);
  const location = useLocation();
  const mainPanel = React.useRef(null);
    
  const getRoutes = (routes_objs) => {
    return routes_objs.map(routes => {
      return routes.subItem.map((prop, key) => {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(props) => <prop.component {...props} />}
            exact={prop.exact}
            key={key}
          />
        );
      });
    })
  };

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element.parentNode.removeChild(element);
    }
  }, [location]);

  return (
    <>
      <div className="wrapper">
        <Sidebar color={color} image={hasImage ? image : ""} routes={routes} />
        <div className="main-panel" ref={mainPanel}>
          <AdminNavbar />
          <div className="content">
            <Switch>{getRoutes(routes)}</Switch>
          </div>
          <Footer />
        </div>
      </div>
      {/* <FixedPlugin
        hasImage={hasImage}
        setHasImage={() => setHasImage(!hasImage)}
        color={color}
        setColor={(color) => setColor(color)}
        image={image}
        setImage={(image) => setImage(image)}
      /> */}
    </>
  );
}
export default Admin;
